import { EditCoursePage } from './EditCoursePage';

export default EditCoursePage;
